import * as Effects from 'redux-saga/effects'
import { all, call, put, take } from 'redux-saga/effects'
import { IntegrationAction } from '../../reducers/airbnb/actionNames'
import fetchActionsName, { ActionNames } from '../../utils/FetchActionsName'
import { callFetch } from '../../actions/fetch'
import toggleSync from '../../models/Integration/toggleSync'

function* setSync(action) {
  try {
    const actionNames = fetchActionsName(ActionNames.ToggleAirbnbSync)
    const [{ service }] = yield all([
      take(actionNames.output),
      put(callFetch(actionNames.input, actionNames.output, toggleSync)),
    ])

    const sync = yield call(service, action.payload)

    yield Effects.put({
      type: IntegrationAction.SetSync,
      payload: sync.items.status,
    })
  } catch (e) {
    console.error(e)
  }
}

export default function*() {
  yield Effects.takeLatest(IntegrationAction.ToggleSync, setSync)
}
